import React from "react";
import { Keyframes, Frame } from "react-keyframes";
import "./Terminal.css";

const delay = {
  before: 1000,
  after: 500
};
const command = {
  change: "cd my-project",
  directory: "~/my-project",
  install: "npm install create-catalog -g",
  create: "create-catalog my-project",
  start: "catalog start",
  starting: "Catalog is starting…",
  running: "Catalog is running"
};

const TerminalLine = ({
  directory = "~/",
  text = "",
  typing = false,
  caret = false,
  highlight = false
}) => {
  const chars = text.length + 1;
  const className =
    "terminalLine" + (caret ? " caret" : "") + (highlight ? " highlight" : "");

  return (
    <p>
      <span className="directory">{directory}</span>
      <span className="prompt">$</span>
      <span
        className={className}
        style={{
          width: `${chars}ch`,
          animation: typing
            ? `typing ${chars * 60}ms steps(${chars}, end)`
            : null
        }}
      >
        {text}
      </span>
    </p>
  );
};

export const Terminal = ({ active, onEnd }) => {
  return (
    <code className="Term">
      {active && (
        <Keyframes onEnd={onEnd}>
          <Frame duration={delay.before}>
            <div className="command">
              <TerminalLine caret />
            </div>
          </Frame>

          <Frame duration={30 * 60 + delay.after}>
            <div className="command">
              <TerminalLine text={command.install} caret typing />
            </div>
          </Frame>

          <Frame duration={delay.before}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine caret />
            </div>
          </Frame>

          <Frame duration={26 * 60 + delay.after}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine text={command.create} typing caret />
            </div>
          </Frame>

          <Frame duration={delay.before}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine text={command.create} />
              <TerminalLine
                text="✔︎ Set up Catalog in ~/my-project/"
                highlight
              />
              <TerminalLine caret />
            </div>
          </Frame>

          <Frame duration={14 * 60 + delay.after}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine text={command.create} />
              <TerminalLine
                text="✔︎ Set up Catalog in ~/my-project/"
                highlight
              />
              <TerminalLine text="cd my-project" typing caret />
            </div>
          </Frame>

          <Frame duration={delay.before}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine text={command.create} />
              <TerminalLine
                text="✔︎ Set up Catalog in ~/my-project/"
                highlight
              />
              <TerminalLine text="cd my-project" />
              <TerminalLine directory="~/my-project" caret />
            </div>
          </Frame>

          <Frame duration={22 * 60 + delay.after}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine text={command.create} />
              <TerminalLine
                text="✔︎ Set up Catalog in ~/my-project/"
                highlight
              />
              <TerminalLine text="cd my-project" />
              <TerminalLine
                directory="~/my-project"
                text="npm run catalog-start"
                typing
                caret
              />
            </div>
          </Frame>

          <Frame duration={2000}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine text={command.create} />
              <TerminalLine
                text="✔︎ Set up Catalog in ~/my-project/"
                highlight
              />
              <TerminalLine text="cd my-project" />
              <TerminalLine
                directory="~/my-project"
                text="npm run catalog-start"
              />
              <TerminalLine
                directory="~/my-project"
                text="Catalog is starting ..."
                caret
              />
            </div>
          </Frame>

          <Frame duration={delay.after}>
            <div className="command">
              <TerminalLine text={command.install} />
              <TerminalLine text={"✔︎ Installed 'create-catalog'"} highlight />
              <TerminalLine text={command.create} />
              <TerminalLine
                text="✔︎ Set up Catalog in ~/my-project/"
                highlight
              />
              <TerminalLine text="cd my-project" />
              <TerminalLine
                directory="~/my-project"
                text="npm run catalog-start"
              />
              <TerminalLine
                directory="~/my-project"
                text="Catalog is running"
                highlight
              />
            </div>
          </Frame>
        </Keyframes>
      )}
    </code>
  );
};



// WEBPACK FOOTER //
// ./src/components/Terminal.js